(function () {
    'use strict';
    angular.module('app').controller('TransitWarrantyClaimDetails', TransitWarrantyClaimDetails);
    TransitWarrantyClaimDetails.$inject = [
        'claimDetails',
        'shipment',
        'TransitWarrantyService',
        'reasonForClaims',
        '$rootScope',
        '$uibModalInstance',
        '$q',
        'toastr',
        'Shipments'
    ];

    function TransitWarrantyClaimDetails(
        claimDetails,
        shipment,
        TransitWarrantyService,
        reasonForClaims,
        $rootScope,
        $uibModalInstance,
        $q,
        toastr,
        Shipments
    ) {
        const vm = this;
        const amountDecimalPlaces = 2;

        vm.submit = onSubmit;
        vm.toggleDatePicker = onToggleDatePicker;
        vm.closeModal = onCloseModal;
        vm.deleteEvidence = deleteEvidence;
        vm.cancelUploadEvidence = cancelUploadEvidence;
        vm.subStringFilename = subStringFilename;

        init();

        async function init() {
            vm.reasonForClaims = reasonForClaims;
            vm.currency = $rootScope.GlobalProfile.office.currency;
            await displayEditOrCreateForm();
        }

        async function displayEditOrCreateForm() {
            if (shipment) {
                await initializeCreateWarrantyClaimData().then();
                return;
            }

            if (claimDetails) {
                await initializeEditWarrantyClaimData().then();
            }
        }

        function onToggleDatePicker() {
            vm.isDatepickerOpen = !vm.isDatepickerOpen;
        }

        function onCloseModal() {
            $uibModalInstance.dismiss();
        }

        function onSubmit(form) {
            form.$setSubmitted();
            if (form.$invalid) {
                return;
            }
            saveData().then();
        }

        async function initializeEditWarrantyClaimData() {
            vm.edit = true;
            vm.loadingDetails = true;
            vm.payoutDatePickerOptions = setPayoutDatePickerOptions();

            const shipmentDetails = await getShipmentDetails();
            if (!shipmentDetails) return;

            const warrantyRates = await getWarrantyRates(shipmentDetails.company.id, shipmentDetails.serviceProfile.carrierProfile.id);
            if (!warrantyRates) return;
            if (warrantyRates.length <= 0) {
                showCannotGetRatesError();
                return;
            }

            setEditWarrantyClaimsDetailsData(shipmentDetails, warrantyRates[0]);
            vm.loadingDetails = false;
        }

        function setPayoutDatePickerOptions() {
            return {
                minDate: new Date(),
                initDate: new Date()
            };
        }

        function setEditWarrantyClaimsDetailsData(shipment, rate) {
            vm.disableDeclaredValue = true;
            vm.details = {
                consignmentNumber: shipment.consignmentId,
                carrierProfile: claimDetails.carrierProfileName,
                customerName: claimDetails.customerName,
                coverageAmount: angular.toFixedNoRounding(rate.coverageAmount, amountDecimalPlaces),
                claimAmount: Number(angular.toFixedNoRounding(claimDetails.claimAmount, amountDecimalPlaces)),
                declaredValue: Number(angular.toFixedNoRounding(claimDetails.declaredValue, amountDecimalPlaces)),
                referenceNumber: claimDetails.referenceNumber,
                reasonForClaim: claimDetails.reasonForClaim,
                notes: claimDetails.notes,
                evidence: claimDetails.evidence
            }
        }

        async function initializeCreateWarrantyClaimData() {
            vm.edit = false;
            vm.loadingDetails = true;

            const shipmentCompanyId = angular.getObjVal(shipment, 'company.id');
            const carrierProfileId = angular.getObjVal(shipment, 'serviceProfile.carrierProfile.id');
            const warrantyRate = await getWarrantyRates(shipmentCompanyId, carrierProfileId);

            if (!warrantyRate) return;
            if (warrantyRate.length <= 0) {
                showCannotGetRatesError();
                return;
            }

            setCreateWarrantyClaimsFormData(warrantyRate[0]);
            vm.loadingDetails = false;
        }

        function showCannotGetRatesError() {
            toastr.error('No Warranty rates found', 'Cannot proceed to create claims');
            $uibModalInstance.dismiss();
        }

        function setCreateWarrantyClaimsFormData(rate) {
            vm.disableDeclaredValue = false;
            vm.warrantyRate = rate;
            vm.details = {
                consignmentNumber: shipment.consignmentId,
                carrierProfile: shipment.serviceProfile.carrierProfile.name,
                customerName: `${shipment.sourceAddress.firstName} ${shipment.sourceAddress.lastName}`,
                coverageAmount: rate.coverageAmount.toFixed(2),
                claimAmount: Number(0),
                declaredValue: getDeclaredValue(),
                shipmentId: shipment.id
            };
        }

        function getDeclaredValue() {
            let total = 0;
            const items = angular.copy(shipment.items);
            items.forEach(itm => {
                total += itm.quality * itm.value;
            });
            return total;
        }

        function getWarrantyRates(companyId, carrierProfileId) {
            return new Promise((resolve, reject) => {
                TransitWarrantyService.Rates.getAll(success => {
                    resolve(success.content);
                }, error => {
                    reject(error);
                }, {
                    companyId: companyId,
                    'carrierProfiles.carrierProfileId': carrierProfileId
                });
            }).catch(error => {
                toastr.error(error.message, 'Error');
            });
        }

        function getShipmentDetails() {
            return new Promise((resolve, reject) => {
                Shipments.getShipmentDetails(claimDetails.shipmentId, data => {
                    resolve(data);
                }, error => {
                    reject(error);
                });
            }).catch(error => {
                toastr.error(error.message, 'Error');
            });
        }

        async function saveData() {
            vm.savingData = true;
            const evidence = await uploadEvidence(vm.file);
            if (!evidence) return;

            if (vm.edit) {
                await callUpdateWarrantyClaimApi(evidence);
                vm.savingData = false;
                return;
            }

            await callCreateWarrantyClaimApi();
            vm.savingData = false;
        }

        function subStringFilename(str){
            const startIndex = 0; // Starting index of the substring
            const length = 10; // Length of the substring
            return str.substring(startIndex, startIndex + length);
        }

        function uploadEvidence(file) {
            return new Promise((resolve, reject) => {
                TransitWarrantyService.Claims.uploadEvidence(success => {
                    resolve(success);
                }, error => {
                    reject(error);
                }, file);
            }).catch(error => {
                toastr.error(error.message, 'Error');
            });
        }

        async function callUpdateWarrantyClaimApi(evidence) {
            vm.details.evidence = evidence.url;
            const warrantyClaim = await updateWarrantyClaim(vm.details, claimDetails.id);
            if (warrantyClaim) {
                toastr.success('Warranty claim successfully updated', 'Success');
                $uibModalInstance.close();
            }
        }

        async function callCreateWarrantyClaimApi() {
            const warrantyClaim = await createWarrantyClaim(vm.details, vm.warrantyRate, vm.details)
            if (warrantyClaim) {
                toastr.success('Warranty claim successfully created', 'Success');
                $uibModalInstance.close();
            }
        }

        function updateWarrantyClaim(details, id) {
            const payload = TransitWarrantyService.Claims.generateUpdateClaimsPayload(details);
            return new Promise((resolve, reject) => {
                TransitWarrantyService.Claims.update(success => {
                    resolve(success);
                }, error => {
                    reject(error);
                }, id, payload);
            }).catch(error => {
                toastr.error(error.message, 'Error');
            });
        }

        function createWarrantyClaim(details, warrantyRate, shipment) {
            const payload = TransitWarrantyService.Claims.generateCreateClaimsPayload(details, warrantyRate, shipment);
            return new Promise((resolve, reject) => {
                TransitWarrantyService.Claims.create(success => {
                    resolve(success);
                }, error => {
                    reject(error)
                }, payload);
            }).catch(error => {
                toastr.error(error.message, 'Error');
            });
        }

        function deleteEvidence() {
            vm.details.evidence = null;
        }

        function cancelUploadEvidence() {
            vm.details.evidence = claimDetails.evidence;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/transit-warranty/modal/TransitWarrantyClaimDetailsModal.js